import { useRef } from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import ProductsPage from './pages/ProductsPage';
import CategoriesPage from './pages/CategoriesPage';
import POSPage from './pages/POSPage';
import LoginPage from './pages/LoginPage';
import ReportsPage from './pages/ReportsPage';
import CajasPage from './pages/CajasPage';
import UsersPage from './pages/UsersPage';
import ProveedoresPage from './pages/ProveedoresPage';
import ComprasPage from './pages/ComprasPage';
import PromotionsPage from './pages/PromotionsPage';
import PreventasPage from './pages/PreventasPage';
import VendedoresBarcodesPage from './pages/VendedoresBarcodesPage';
import ColaboradoresPage from './pages/ColaboradoresPage';
import RolesPage from './pages/RolesPage';
import AgendaPage from './pages/AgendaPage';
import VentasPage from './pages/VentasPage';
import FlujoCajaPage from './pages/FlujoCajaPage';
import InventoriesPage from './pages/InventoriesPage';
import ActiveUsersPage from './pages/ActiveUsersPage';
import SucursalesPage from './pages/SucursalesPage';
import BodegasPage from './pages/BodegasPage';
import StockPage from './pages/StockPage';
import ExpirationPage from './pages/ExpirationPage';
import HelpPage from './pages/HelpPage';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoadingSpinner from './components/LoadingSpinner';
import './App.css';

const PrivateRoute = () => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: 'var(--bg-body)' }}>
        <LoadingSpinner message="Verificando sesión..." />
      </div>
    );
  }
  return user ? <Outlet /> : <Navigate to="/login" />;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route element={<PrivateRoute />}>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="products" element={<ProductsPage />} />
          <Route path="categories" element={<CategoriesPage />} />
          <Route path="pos" element={<POSPage />} />
          <Route path="reports" element={<ReportsPage />} />
          <Route path="cajas" element={<CajasPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="proveedores" element={<ProveedoresPage />} />
          <Route path="compras" element={<ComprasPage />} />
          <Route path="promociones" element={<PromotionsPage />} />
          <Route path="preventas" element={<PreventasPage />} />
          <Route path="vendedores-barcodes" element={<VendedoresBarcodesPage />} />
          <Route path="colaboradores" element={<ColaboradoresPage />} />
          <Route path="roles" element={<RolesPage />} />
          <Route path="agenda" element={<AgendaPage />} />
          <Route path="ventas" element={<VentasPage />} />
          <Route path="flujo-caja" element={<FlujoCajaPage />} />
          <Route path="inventarios" element={<InventoriesPage />} />
          <Route path="usuarios-activos" element={<ActiveUsersPage />} />
          <Route path="sucursales" element={<SucursalesPage />} />
          <Route path="bodegas" element={<BodegasPage />} />
          <Route path="stock" element={<StockPage />} />
          <Route path="vencimientos" element={<ExpirationPage />} />
          <Route path="ayuda" element={<HelpPage />} />
        </Route>
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
